import React, { useState, useEffect } from 'react'
import { Trans } from 'react-i18next'
import store from '@services/Store'
import { clearStore } from '../../index.Dux'
import { clearServices } from '../../utilities/actions'
import Consultations from '../../Services/Consultations'
import { useTranslation } from 'react-i18next'
import MDBanner from '../core/components/MD.Banner'
import history from '@services/History'
import SignInWrapper from './signinWrapper'

const PasswordForgotten = () => {
  // state
  const [email, setEmail] = useState('')
  const [success, setSuccess] = useState(null)
  const [error, setError] = useState(null)
  const { t } = useTranslation()

  useEffect(() => {
    clearServices()
    store.dispatch(clearStore())
  }, [])

  const recoveryPassword = async () => {
    if (!email) {
      setError('no-email')
      return
    }
    try {
      let langLocaleStorage = window.localStorage.getItem('i18nextLng')
      await Consultations.auth.passwordForgotten({ email, language_code: langLocaleStorage })

      setSuccess(t('emailCorrectResetPassword'))
      setError(null)
    } catch (e) {
      setSuccess(null)
      setError('emailNotSent')
    }
    setTimeout(() => {
      history.push('/')
    }, 5000)
  }

  return (
    <SignInWrapper>
      <div id="header" />

      <h2>
        <Trans>Restablecer la contraseña</Trans>
      </h2>

      <input type="email" onChange={(e) => setEmail(e.target.value)} placeholder={t('Email')} />

      {success && <MDBanner message={success} onClose={() => setSuccess(null)} success />}
      {error && <MDBanner message={error} onClose={() => setError(null)} error />}

      <div className="buttons-container">
        <button onClick={() => recoveryPassword()}>{t('Enviar')}</button>
      </div>
    </SignInWrapper>
  )
}

export default PasswordForgotten
